import React from "react";
import { useHistory } from "react-router-dom";
import { awsInstance } from "../../actions/api";
import { setPhoneTemplate } from "../../actions/utiles";

function EmployeeListItem({ employee, onChangeCheckbox }) {
  const link = useHistory();

  const linkToDetail = (params) => {
    link.push(`/employee-detail/${params}`);
  };

  const onTextColorChange = (status) => {
    if (status === 100) {
      return "txt-red";
    } else {
      return "txt-dark-gray";
    }
  };

  const onSendAuthEmail = async () => {
    try {
      const { data } = await awsInstance.post("/business/employee/email", {
        id: employee.id
      });
      if (data.code === "SUCCESS") {
        alert('이메일을 재전송하였습니다.')
      }
    } catch (e) {
      alert(e);
    }    
  };

  return (
    <>
      {employee && (
        <>
          <tr key={employee.key}>
            <th>
              <input
                className="float-left checkbox"
                type="checkbox"
                name="check"
                value={employee.id}
                onChange={onChangeCheckbox}
              />
              <span
                className="pl-1 underline-black underline-hover-blue cursor txt-center"
                onClick={() => linkToDetail(`${employee.id}`)}
              >
                {employee.email}
              </span>
            </th>
            <th>
              <span className="txt-dark-gray">{employee.name}</span>
            </th>
            <th>
              <span className="txt-dark-gray">
                {setPhoneTemplate(employee.phone_number)}
              </span>
            </th>
            <th>
              <span className="txt-dark-gray">
                {employee.department ? employee.department : "-"}
              </span>
            </th>
            <th>
              <span className="txt-dark-gray">
                {employee.business_group_name
                  ? employee.business_group_name
                  : "-"}
              </span>
            </th>
            <th className="p-1">
              <span className={onTextColorChange(employee.status)}>
                {employee.status === 100 ? (
                  <>
                    <p className="m-1">미가입</p>
                    <button
                      className="btn-white-sm long pl-2 pr-2"
                      onClick={onSendAuthEmail}>
                      이메일 재전송
                    </button>
                  </>
                ) : employee.status === 200 ? (
                  "정상"
                ) : (
                  "휴직"
                )}
              </span>
            </th>
          </tr>
        </>
      )}
    </>
  );
}

export default EmployeeListItem;
